import { Map } from 'immutable';
import moment from 'moment';

import StringFormatHelper from '../helpers/StringFormatHelper';

const DEFAULT_DATE_FORMAT = 'YYYY-MM-DD\THH:mm:ss\Z';
const DEFAULT_DATE_MASK = 'DD/MM/YYYY';

export default class Person {
    constructor(data) {
        if (!data) {
            this.data = Map({
                numberOfQuotes: '3',
                telephonyAdvice: true,
                dbPension: false,
            });
        } else {
            this.data = data;
        }
    }

    static build(data) {
        return new Person(data);
    }

    get(attributeName) {
        return this.data.get(attributeName);
    }

    delete(attributeName) {
        this.data = this.data.delete(attributeName);
    }

    setMutable(attributeName, value) {
        this.data = this.data.set(attributeName, value);
    }

    set(attributeName, value) {
        return this.data.set(attributeName, value);
    }

    getFullName() {
        return `${this.data.get('firstName')} ${this.data.get('lastName')}`;
    }

    getDateOfBirth() {
        if (!this.data.get('dateOfBirth')) {
            return '';
        }

        return moment(this.data.get('dateOfBirth')).format(DEFAULT_DATE_MASK);
    }

    setDateOfBirth(dateOfBirth) {
        if (!dateOfBirth || !dateOfBirth.trim()) {
            this.data = this.data.set('dateOfBirth', '');
            return;
        }

        if (/\d\d\/\d\d\/\d\d$/.test(dateOfBirth.trim())) {
            const [day, month, year] = dateOfBirth.split('/');
            const twoDigitCurrentYear = moment().year() - 2000;
            let fourDigitYear = moment().year();

            if (year < twoDigitCurrentYear) {
                fourDigitYear = 2000 + parseInt(year);
            } else {
                fourDigitYear = 1900 + parseInt(year);
            }

            this.data = this.data.set('dateOfBirth',
                moment(`${day}/${month}/${fourDigitYear}`, DEFAULT_DATE_MASK).format(DEFAULT_DATE_FORMAT));
        } else if (moment(dateOfBirth, DEFAULT_DATE_MASK).isValid()) {
            this.data = this.data.set('dateOfBirth',
                moment(dateOfBirth, DEFAULT_DATE_MASK).format(DEFAULT_DATE_FORMAT));
        } else {
            this.data = this.data.set('dateOfBirth',
                moment().format(DEFAULT_DATE_FORMAT));
        }
    }

    getDataAsJSON() {
        const requestData = {
            advice_area: !isNaN(parseInt(this.data.get('adviceArea'))) ?
                parseInt(this.data.get('adviceArea')) : 393,
            number_of_quotes: !isNaN(parseInt(this.data.get('numberOfQuotes'))) ?
                parseInt(this.data.get('numberOfQuotes')) : 3,
            message: this.data.get('message'),
            vertical: 5,
            source: 'discover-mortgage',
            customer: {
                name: this.data.get('fullName'),
                email: this.data.get('email'),
                phone: this.data.get('phone'),
                postcode: this.data.get('postcode'),
            },
            isLocationImportant: this.data.get('isLocationImportant'),
        };

        if (this.data.get('adviceArea') !== 392) {
            requestData.wealth_level = StringFormatHelper.formatToNumber(this.data.get('wealthLevel'));
            requestData.telephony_advice = this.data.get('telephonyAdvice');
        } else {
            const depositValue = StringFormatHelper.formatToNumber(this.data.get('deposit'));
            const mortgageValue = StringFormatHelper.formatToNumber(this.data.get('mortgageValue'));
            requestData.mortgage_value = mortgageValue - depositValue;
            requestData.annual_income = StringFormatHelper.formatToNumber(this.data.get('annualIncome'));
            requestData.deposit = depositValue;
            requestData.advice_time = this.data.get('adviceTime');
        }

        return requestData;
    }

    getDataAsSearchParams() {
        const params = {};
        if (this.data.get('adviceArea')) {
            params.attribute_ids = this.data.get('adviceArea');
        }

        if (this.data.get('postcode')) {
            params.location = this.data.get('postcode');
        }

        if (this.data.get('wealthLevel')) {
            params.wealth_level_ids = Person.getWealthLevelIds(this.data.get('wealthLevel'));
        }

        if (this.data.get('mortgageValue')) {
            params.mortgage_level_ids = Person.getMortgageValueIds(this.data.get('mortgageValue'));
        }

        return params;
    }

    static getWealthLevelIds(value) {
        const integerValue = StringFormatHelper.formatToNumber(value);

        if (!integerValue || isNaN(integerValue)) {
            return '';
        }

        if (integerValue < 50000) {
            return '402';
        }

        if (integerValue < 100000) {
            return '402,403';
        }

        if (integerValue < 250000) {
            return '402,403,404';
        }

        if (integerValue < 500000) {
            return '402,403,404,405';
        }

        return '402,403,404,405,406';
    }

    static getMortgageValueIds(value) {
        const integerValue = StringFormatHelper.formatToNumber(value);

        if (!integerValue || isNaN(integerValue)) {
            return '';
        }

        if (integerValue < 50000) {
            return '408';
        }

        if (integerValue < 100000) {
            return '408,587';
        }

        if (integerValue < 250000) {
            return '408,587,409';
        }

        if (integerValue < 500000) {
            return '408,587,409,410';
        }

        if (integerValue < 1000000) {
            return '408,587,409,410,411';
        }

        return '408,587,409,410,411,412';
    }
}



// WEBPACK FOOTER //
// ./src/model/Person.js